module.exports = __webpack_public_path__ + "img/open-email.a49ee5f1.svg";